import Button from "../Button.jsx";

export default function FormButton({className, children, size, onClick, disabled = false}) {
    return (
        <div className={'text-right mt-2'}>
            <Button
                onClick={onClick}
                size={size}
                disabled={disabled}
                className={className}
            >
                {children}
            </Button>
        </div>
    );
}
